export default __webpack_public_path__ + "static/17_18-0e9b2a72aaf6a8b9eb049fa0de7d580d.png";